import {STATE_PROP_NAME} from './flag-article-modal-constants'

export const getState = state => state[STATE_PROP_NAME]
export const getIsLoadingArray = state => getState(state).isLoadingArray
export const getFlaggings = state => getState(state).flaggingData.flaggings
